module.exports = __webpack_public_path__ + "static/img/half-round-14.64ea74e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/receptacles/half-round-14.jpg
// module id = 606
// module chunks = 0